export function setUsers(state, payload) {
  state.users = payload
}

export function addUser(state, payload) {
  if (Array.isArray(state.users)) {
    // Mevcut kullanıcıyı userId veya userUuid ile bul
    const existingUserIndex = state.users.findIndex(user => user.uuid === payload.userUuid)

    // Gelen payload'ı dönüştür
    const transformedUser = {
      status: payload.type,
      uuid: payload.userUuid,
      userName: payload.userName,
      updatedAt: payload.timestamp,
    }

    if (existingUserIndex !== -1) {
      // Mevcut kullanıcıyı güncelle
      state.users.splice(existingUserIndex, 1, transformedUser)
    } else {
      // Yeni kullanıcı ekle
      state.users.push(transformedUser)
    }
  }
}
